/**
 * firebase.ts — Firebase SDK 초기화 + 인스턴스 export
 *
 * 모든 Firebase 호출은 이 파일에서 export된 인스턴스를 통해서만 한다.
 * 직접 `firebase/app`, `firebase/auth` 등을 import하지 말 것 (services/ 안 제외).
 *
 * 에뮬레이터: URL에 ?emulator=1 이 있을 때만 옵트인 연결.
 */
import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, connectAuthEmulator, type Auth } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator, type Firestore } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator, type Functions } from "firebase/functions";

// secret-scan: allow — Firebase 웹 config 의 apiKey 는 비밀이 아니라 프로젝트 식별자입니다.
// 브라우저 번들에 그대로 실려야 하며, 실제 보호는 Firestore rules + Auth 가 담당합니다.
const firebaseConfig = {
  apiKey: "AIzaSyAIFZLqWSVl9Kk5isWoSCl9UXliJV-YzeI",
  authDomain: "joongang-intergated-management.firebaseapp.com",
  projectId: "joongang-intergated-management",
  storageBucket: "joongang-intergated-management.firebasestorage.app",
  messagingSenderId: "238269550607",
  appId: "1:238269550607:web:1ab2d902c1adce9f7f137a",
};

export const FUNCTIONS_REGION = "asia-northeast3";
export const INTERNAL_EMAIL_DOMAIN = "@rmc-internal.local";

export const app: FirebaseApp = initializeApp(firebaseConfig);
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const functions: Functions = getFunctions(app, FUNCTIONS_REGION);

auth.languageCode = "ko";

const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

const useEmulator =
  typeof window !== "undefined" &&
  new URLSearchParams(window.location.search).get("emulator") === "1";

if (isLocalHost && useEmulator) {
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "localhost", 8080);
  connectFunctionsEmulator(functions, "localhost", 5001);
  console.info("[Firebase] 에뮬레이터 연결됨");
}
